import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useClientAboutPageRedirect = () => {
  return usePagesRedirect('clientAboutPage');
};
